

























































































































































import api from '@/services/api';
import { Component, Vue, Prop } from 'vue-property-decorator';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import UserProfile from '@/classes/UserProfile';
import { StudentProfile, IStudentProfile } from '@/classes/StudentProfile';
import authorize, { Office } from '@/services/Authorize';
import Certification from '@/classes/Certification';
import { Certificate, ICertificate } from '@/classes/Certificate';
import CertificateForm from '@/classes/CertificateForm';
import { dateFormatter } from '@/services/inputTools';
import { IStudentControllerResponse, IStudentControllerRequest } from '@/classes/ControllerInterface/StudentController.ts';
import moment from 'moment';
import { dateTwoDigitYearFormatter } from '@/services/dateTool';
import _ from 'underscore';
import ReprintModal from '@/views/certificates/ReprintModal.vue';
import { parse as parseDate, isValid as isValidDate } from 'date-fns';
import bootbox from 'bootbox';
import { NAME_REGEX } from '@/validation';

@Component({
  components: {
    ReprintModal
  }
})
export default class CertReqForm extends Vue {
  @Prop() public id!: number;
  @Prop({ default: false }) public view!: boolean;

  public courseSelected: number | null = null;
  public instructorSelected: number | null = null;
  public centerSelected: number | null = null;

  public courseHasBeenSelected: boolean = false;

  public lookupPressed: boolean = false;
  public studentFound: boolean = false;

  public currentStudent: StudentProfile = new StudentProfile();
  public currentCertificates: Certificate[] = [];
  public studentsArray: StudentProfile[] = [];

  public printLocation: boolean = false;

  public editingStudent: boolean = false;
  public editingStudentArraylocation: number = -1;

  public formId: number | null = null;

  public get studentFirstName(): string {
    return (this.currentStudent.firstName || '').trim();
  }

  public set studentFirstName(value: string) {
    this.currentStudent.firstName = value;
  }

  public get studentFirstNameIsValid(): boolean {
    return !_(this.studentFirstName).isEmpty() && NAME_REGEX.test(this.studentFirstName);
  }

  public get studentMiddleName(): string {
    return (this.currentStudent.middleName || '').trim();
  }

  public set studentMiddleName(value: string) {
    this.currentStudent.middleName = value;
  }

  public get studentMiddleNameIsValid(): boolean | null {
    // Middle Name is optional - so don't show invalid feedback when it is empty
    if (_(this.studentMiddleName).isEmpty()) {
      return null;
    }

    return NAME_REGEX.test(this.studentMiddleName);
  }

  public get studentLastName(): string {
    return (this.currentStudent.lastName || '').trim();
  }

  public set studentLastName(value: string) {
    this.currentStudent.lastName = value;
  }

  public get studentLastNameIsValid(): boolean {
    return !_(this.studentLastName).isEmpty() && NAME_REGEX.test(this.studentLastName);
  }

  get alreadyAwardedCerts(): Certificate[] {
    if (this.currentCertificates && this.currentCertificates.length > 0 && this.courseSelected) {
      const filtered: Certificate[] | undefined = this.currentCertificates.filter((certificate: Certificate) => {
        return certificate.certificationId === this.courseSelected;
      });
      return filtered !== undefined ? filtered : [];
    } else {
      return [];
    }
  }

  get matchingCerts(): Certificate[] {
    return this.alreadyAwardedCerts.filter((cert: Certificate): boolean => {
      if (this.currentStudent.certificationDate !== undefined && this.currentStudent.certificationDate !== null) {
        const contains: boolean | undefined = moment(cert.certificationDate).isSame(this.currentStudent.certificationDate, 'day');
        return contains !== undefined ? contains : false;
      } else {
        return false;
      }
    });
  }

  get alreadyAwardedCertString(): string {
    if (this.matchingCerts.length > 0) {
      return 'Certificates must have different completion dates.';
    } else {
      return '';
    }
  }

  get alreadyAwardedCertsString(): string | undefined {
    let dates: string = '';
    if (this.alreadyAwardedCerts.length > 0) {
      if (this.alreadyAwardedCerts.length === 1) {
        dates = dateFormatter(this.alreadyAwardedCerts[0].certificationDate);
      } else {
        dates = this.alreadyAwardedCerts
          .map((certDate: Certificate): string => {
            return dateFormatter(certDate.certificationDate);
          })
          .join(', ');
      }
      dates = ' Already awarded this certificate on ' + dates + '.';
    }
    return dates;
  }

  get certDateInvalid(): boolean | null {
    if (this.currentStudent.certificationDate && this.currentStudent.certificationDate.length > 6) {
      if (moment(this.currentStudent.certificationDate).isValid()) {
        return this.matchingCerts.length === 0;
      } else {
        return false;
      }
    } else {
      return null;
    }
  }

  public created() {
    this.updateForm();
  }

  public dateTwoDigitYearFormatter(value: string, event: any): string {
    return dateTwoDigitYearFormatter(value, event);
  }
  public checkStudentId() {
    if (this.currentStudent.dolId && this.currentStudent.dolId.length === 7) {
      const studentIndex: number = this.studentsArray.findIndex((student: StudentProfile) => student.dolId === this.currentStudent.dolId);
      if (studentIndex !== -1) {
        this.editStudentInArray(this.currentStudent.dolId);
      } else {
        this.checkStudentDolId()
          .then((data: boolean) => {
            if (data) {
              this.studentFound = true;
            } else {
              this.studentFound = false;
            }
          })
          .catch(() => {
            bootbox.alert('There was an issue checking Student ID.');
          })
          .finally(() => {
            this.lookupPressed = true;
          });
      }
    } else {
      bootbox.alert('Student ID should be 7 digits.');
    }
  }

  public resetStudentForm() {
    this.studentFound = false;
    this.lookupPressed = false;
    this.currentStudent = new StudentProfile();
    this.currentCertificates = [];
    this.editingStudent = false;
    this.editingStudentArraylocation = -1;
  }

  public addStudentToArray() {
    const isValid = this.checkStudentValidity();

    if (!isValid) {
      return;
    }

    this.currentStudent.jobCorpsCenterId = this.centerSelected ? this.centerSelected : undefined;
    this.studentsArray.push(this.currentStudent);
    this.resetStudentForm();
  }

  public checkStudentValidity(): boolean {
    const errors: string[] = [];

    if (!isValidDate(parseDate(this.currentStudent.certificationDate || ''))) {
      errors.push(`Certificate Completion Date must be provided`);
    }

    if (!this.studentFirstNameIsValid) {
      errors.push(`Please enter a valid First name`);
    }

    if (!_(this.currentStudent.middleName).isEmpty() && !NAME_REGEX.test(this.currentStudent.middleName || '')) {
      errors.push(`Please enter a valid Middle name`);
    }

    if (!this.studentLastNameIsValid) {
      errors.push(`Please enter a valid Last name`);
    }

    const isValid = _(errors).isEmpty();

    if (!isValid) {
      bootbox.alert(`
      <div style="font-weight:bold">Please correct the following:</div>
      <div style="padding-top: 10px">
        <ol>
          <li>${errors.join('</li><li>')}</li>
        </ol>
      </div>`);
    }

    return isValid;
  }

  get isStudentFound() {
    if (this.studentFound) {
      return 'Student found.' + this.alreadyAwardedCertsString;
    } else {
      return '';
    }
  }
  get courseList(): Certification[] {
    const courses: Certification[] | undefined = this.$store.getters.getCertifications;

    if (!_(courses).isArray()) {
      return [];
    }

    return _(courses).filter((c) => true === c.visible);
  }

  public setCourseForm() {
    if (this.courseSelected !== null) {
      this.courseHasBeenSelected = true;
    }
  }

  public resetCourseForm() {
    if (this.studentsArray.length > 0 && confirm('This will remove all students from the request.')) {
      this.courseHasBeenSelected = false;
      this.courseSelected = null;
      this.centerSelected = null;
      this.instructorSelected = null;
      this.studentsArray = [];
      this.resetStudentForm();
    } else if (this.studentsArray.length === 0) {
      this.courseHasBeenSelected = false;
      this.courseSelected = null;
      this.centerSelected = null;
      this.instructorSelected = null;
      this.resetStudentForm();
    }
  }

  get certCompletedDateString(): string {
    return '';
  }

  get dolIdInputState(): boolean {
    if (this.studentFound && false) {
      return false;
    } else {
      return true;
    }
  }

  public getCourseName(id: number): string {
    const courseList: Certification[] | undefined = this.courseList;
    if (courseList !== undefined && courseList.length > 0) {
      const index: number = courseList.findIndex((certification: Certification) => certification.id === id);
      if (index > -1) {
        const name: string | undefined = courseList[index].name;
        return name !== undefined ? name : '';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  get userProfileList(): UserProfile[] {
    const instructors = this.$store.getters.getJobCorpsCenterInstructorsById(this.centerSelected) || ([] as UserProfile[]);

    return _.chain(instructors)
      .filter((i) => {
        return i.active;
      })
      .sortBy((i: UserProfile) => {
        return i.firstName;
      })
      .value();
  }

  get activeUserProfile(): UserProfile | undefined {
    return this.$store.getters.getActiveProfile;
  }

  get jobCorpCenters(): JobCorpsCenter[] {
    let jobCorpsCenters: JobCorpsCenter[];
    if (authorize(Office)) {
      jobCorpsCenters = this.$store.getters.getJobCorpsCenters;
    } else {
      const centers: number[] = this.$store.getters.getActiveProfile ? this.$store.getters.getActiveProfile.jobCorpsCenterIds : [];
      jobCorpsCenters = this.$store.getters.getJobCorpsCenters.filter((s: JobCorpsCenter) => (s.id !== undefined ? centers.includes(s.id) : false));
    }

    return _(jobCorpsCenters).sortBy((c) => c.name);
  }

  get fields() {
    return [
      {
        key: 'dolId',
        label: 'Student ID',
        sortable: true
      },
      {
        key: 'name',
        label: 'Name',
        sortable: true
      },
      {
        key: 'certificationDate',
        label: 'Date',
        sortable: true
      },
      {
        key: 'details',
        label: '',
        sortable: false
      }
    ];
  }

  public getJobCorpsCenterName(id: number): string {
    const center: JobCorpsCenter = this.$store.getters.getJobCorpsCenterById(id);
    if (center && center.name !== undefined && center.name !== null) {
      return center.name;
    } else {
      return '';
    }
  }

  public getUserProfileName(id: number) {
    const user = this.$store.getters.getUserProfileById(id);
    if (user) {
      return user.getFullName();
    } else {
      return '';
    }
  }

  public submit() {
    if (!this.checkSubmission()) {
      return;
    }

    const url: string = 'certificaterequest/add';
    this.studentsArray.forEach((stu: StudentProfile) => (stu.jobCorpsCenterId = this.centerSelected as number));
    api()
      .post(url, {
        students: this.studentsArray,
        certificationId: this.courseSelected,
        jobCorpsCenterId: this.centerSelected,
        instructorId: this.instructorSelected,
        printAtITC: this.printLocation,
        certificateId: this.id
      })
      .then((response) => {
        bootbox.alert(response.data.message, () => {
          if (response.data.form !== undefined && response.data.form !== undefined && response.data.certificateRequestCreated) {
            this.$store.dispatch('loadCertificateForms', true).then(() => {
              const form = CertificateForm.certificateFormFromAPI(response.data.form);
              const route = { path: `/forms/certificaterequestform/${form.id}` };

              if (!form.printAtITC) {
                (route as any).query = { printing: 'yes' };
              }

              this.$router.push(route);
            });
          }
        });
      })
      .catch((e) => {
        console.error(e);
        bootbox.alert('Something went wrong.');
      });
  }

  public printPopup(certificatePrintURL: string) {
    const myPopup = window.open(certificatePrintURL);
  }

  public checkSubmission(): boolean {
    const errors: string[] = [];

    if (this.courseSelected === null) {
      errors.push('Course Name must be selected');
    }
    if (this.centerSelected === null) {
      errors.push('Center must be selected');
    }

    if (this.instructorSelected === null) {
      errors.push('Instructor must be selected');
    }
    if (this.studentsArray.length === 0) {
      errors.push('At least one student must be entered.');
    }

    const isValid = _(errors).isEmpty();

    if (!isValid) {
      bootbox.alert(`
      <div style="font-weight:bold">Please correct the following:</div>
      <div style="padding-top: 10px">
        <ol>
          <li>${errors.join('</li><li>')}</li>
        </ol>
      </div>`);
    }

    return isValid;
  }

  public removeFromStudentArray(dolId: string) {
    const studentIndex: number = this.studentsArray.findIndex((student: StudentProfile) => student.dolId === dolId);
    if (studentIndex !== -1) {
      this.studentsArray.splice(studentIndex, 1);
    }
  }

  public editStudentInArray(dolId: string) {
    const studentIndex: number = this.studentsArray.findIndex((student: StudentProfile) => student.dolId === dolId);
    if (studentIndex !== -1) {
      const certDate: string | null | undefined = this.studentsArray[studentIndex].certificationDate;
      this.checkStudentDolId(this.studentsArray[studentIndex].dolId).then((val: boolean) => {
        if (val === false) {
          this.currentStudent = this.studentsArray[studentIndex]; // New student who wasn't found on lookup
        }
        this.currentStudent.certificationDate = certDate !== undefined ? certDate : null;
        this.editingStudent = true;
        this.studentFound = true;
        this.lookupPressed = true;
        this.editingStudentArraylocation = studentIndex;
      });
    }
  }

  public insertEditedStudentIntoArray() {
    if (this.editingStudentArraylocation !== -1) {
      const isValid = this.checkStudentValidity();

      if (!isValid) {
        return;
      }
      this.studentsArray.splice(this.editingStudentArraylocation, 1);
      this.studentsArray.push(this.currentStudent);
      this.editingStudent = false;
      this.editingStudentArraylocation = -1;
      this.resetStudentForm();
    }
  }

  public checkStudentDolId(val?: string): Promise<boolean> {
    const dolId: string | undefined = val !== undefined ? val : this.currentStudent.dolId;
    const url: string = 'student/dolId/search';
    return api()
      .post(url, {
        dolId
      } as IStudentControllerRequest)
      .then((res) => {
        this.currentCertificates = [];
        if (res.data !== null) {
          const response: IStudentControllerResponse = res.data as IStudentControllerResponse;
          if (response.student !== undefined) {
            this.currentStudent = new StudentProfile(response.student);
            if (response.certificates !== undefined) {
              this.currentCertificates = response.certificates.map((e: ICertificate) => new Certificate(e));
            }
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .catch(() => {
        return false;
      });
  }

  public getStudentProfiles(certIds: number[]): StudentProfile[] {
    const students: StudentProfile[] = [];
    api()
      .post('certificaterequest/search', {
        certificateIds: certIds
      })
      .then((response: any) => {
        if (response.data.success) {
          response.data.certificates.forEach((cert: ICertificate) => {
            const certificate: Certificate = new Certificate(cert);
            if (certificate !== null && certificate.studentId !== undefined) {
              const student: any | undefined = response.data.students.find((studentJSON: any) => studentJSON.id === certificate.studentId);
              if (student !== undefined) {
                const studentProfile: StudentProfile = new StudentProfile(student as IStudentProfile);
                studentProfile.certificationDate = certificate.certificationDate;
                students.push(studentProfile);
              }
            }
          });
        }
      });
    return students;
  }

  public updateForm() {
    if (this.id !== undefined && !isNaN(this.id)) {
      if (this.$route.query.printing === 'yes') {
        this.showReprintModal();
      }

      this.$store.dispatch('loadCertificateForms').then(() => {
        const certForm: CertificateForm | undefined = this.$store.getters.getCertificateFormById(this.id);
        if (certForm !== undefined) {
          this.courseSelected = certForm.certificationId ? certForm.certificationId : null;
          this.courseHasBeenSelected = true;
          this.instructorSelected = certForm.instructorId ? certForm.instructorId : null;
          this.centerSelected = certForm.jobCorpsCenterId ? certForm.jobCorpsCenterId : null;
          this.printLocation = certForm.printAtITC as boolean;
          this.studentsArray = this.getStudentProfiles(certForm.certificateIds as number[]);
        } else if (this.view) {
          bootbox.alert('Certificate request form was not found.');
          this.$router.push('/forms');
        }
      });
    }
  }

  public showReprintModal() {
    this.$nextTick(() => (this.$refs.reprintModal as any).show());
  }
}
